import Vuex from 'vuex'
import Vue from 'vue'
import VuexPersist from 'vuex-persist'
import moment from 'moment'
import createSharedMutations from 'vuex-shared-mutations'

Vue.use(Vuex)

const vuexPersist = new VuexPersist({
  key: 'security-store',
  storage: localStorage
})

let sessionInterval = null
const SESSION_DURATION_MIN = 30

export default new Vuex.Store({
  plugins: [vuexPersist.plugin, createSharedMutations({
    // enables real-time synchronization of states and mutations across multiple tabs or windows, used for reactivity in computed properties
    predicate: ['setIsAuth', 'unsetIsAuth', 'setSessionExpTime']
  })],
  state: {
    claims: [],
    expirationDate: null,
    isAuth: false,
    username: '',
    fullName: {},
    userId: '',
    organizationId: '',
    sessionExpTime: null
  },
  getters: {
    claims: (state) => state.claims,
    expirationDate: (state) => state.expirationDate,
    isAuth: (state) => state.isAuth,
    username: (state) => state.username,
    fullName: (state) => state.fullName,
    userId: state => state.userId,
    organizationId: state => state.organizationId,
    sessionExpTime: (state) => state.sessionExpTime
  },
  mutations: {
    setClaims (state, newClaims) {
      state.claims = newClaims
    },
    setIsAuth (state) {
      state.isAuth = true
    },
    unsetIsAuth (state) {
      state.isAuth = false
    },
    setUsername (state, newUsername) {
      state.username = newUsername
    },
    setFullName (state, { nameKey, nameValue }) {
      if (typeof state.fullName !== 'object') {
        state.fullName = {}
      }
      if (nameKey) {
        state.fullName[nameKey] = nameValue
      }
    },
    setUserId (state, userId) {
      state.userId = userId
    },
    setOrganizationId (state, organizationId) {
      state.organizationId = organizationId
    },
    setSessionExpTime (state, newSessionExpTime) {
      state.sessionExpTime = newSessionExpTime
    },
    resetState (state) {
      state.claims = []
      state.expirationDate = null
      state.isAuth = false
      state.username = ''
      state.fullName = {}
      state.userId = ''
      state.organizationId = ''
      state.sessionExpTime = null
    }
  },
  actions: {
    setClaims (context, newClaims) {
      context.commit('setClaims', newClaims)
    },
    setExpirationDate (context, newDate) {
      context.commit('setExpirationDate', newDate)
    },
    setIsAuth ({ commit }) {
      commit('setIsAuth')
    },
    unsetIsAuth ({ commit }) {
      commit('unsetIsAuth')
    },
    setUsername (context, username) {
      context.commit('setUsername', username)
    },
    setFullName (context, { nameKey, nameValue }) {
      context.commit('setFullName', { nameKey, nameValue })
    },
    setUserId (context, userId) {
      context.commit('setUserId', userId)
    },
    setOrganizationId (context, organizationId) {
      context.commit('setOrganizationId', organizationId)
    },
    updateSessionExpTime ({ commit }) {
      commit('setSessionExpTime', moment().add(SESSION_DURATION_MIN, 'minutes'))
    },
    startSessionInterval ({ dispatch, getters }) {
      dispatch('updateSessionExpTime')
      // Set an interval to check every 5s whether the session expiration time has elapsed
      if (sessionInterval) return
      sessionInterval = setInterval(() => {
        // in case that "isAuth" is not updated before the interval starts
        if (!getters.isAuth) return

        if (moment().diff(getters.sessionExpTime) >= 0) {
          dispatch('stopSessionInterval')
          dispatch('unsetIsAuth')
        }
      }, 5000)
    },
    stopSessionInterval () {
      if (!sessionInterval) return
      clearInterval(sessionInterval)
      sessionInterval = null
    },
    resetState ({ commit, dispatch }) {
      commit('resetState')
      dispatch('stopSessionInterval')
    }
  }
})
